import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "toggle"]
  static values = { more: String, less: String }

  connect () {
    this.expanded = false
    this.updateToggleVisibility()
  }

  toggle () {
    this.expanded = !this.expanded
    this.bodyTarget.classList.toggle("is-expanded", this.expanded)
    this.toggleTarget.textContent = this.expanded ? this.lessValue : this.moreValue
  }

  updateToggleVisibility () {
    if (!this.hasBodyTarget || !this.hasToggleTarget) return

    const overflows = this.bodyTarget.scrollHeight > this.bodyTarget.clientHeight + 1
    this.toggleTarget.classList.toggle("d-none", !overflows)
  }
}
